import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { emptyUserData, UserData, UserEntitlementService } from '@ddv/entitlements';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { catchError, Observable, of } from 'rxjs';

export const userResolver: ResolveFn<UserData> = (): Observable<UserData> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(UserEntitlementService);

    return service.fetchUserData()
        .pipe(catchError((error) => {
            errorCollector.addError('Failed to load user data', error);
            return of(emptyUserData());
        }));
};
